namespace $.$$ {

	type $shm_dashboard_admin_auth_response = {
		token?: string
		record?: {
			id?: string
			email?: string
		}
		message?: string
	}

	export class $shm_dashboard_admin_auth extends $.$shm_dashboard_admin_auth {

		dashboard_options(): Record< string, string > {
			const options = {
				'https://dashboard.shmakov.media/': 'https://dashboard.shmakov.media/',
				'https://dashboard.158-160-195-195.ip.hyoo.ru/': 'https://dashboard.158-160-195-195.ip.hyoo.ru/',
			}
			if( [ 'localhost', '127.0.0.1' ].includes( this.$.$mol_dom_context.location.hostname ) ) {
				return { 'http://dashboard.localhost:9080/': 'Локальный сервер', ... options }
			}
			return options
		}

		dashboard_url_default() {
			return Object.keys( this.dashboard_options() )[0] ?? ''
		}

		dashboard_url_known( url: string ) {
			const options: Record< string, string > = this.dashboard_options()
			return Boolean( options[ url ] )
		}

		dashboard_url_normalize( url: string ) {
			return url.trim().replace( /\/+$/, '' ) + '/'
		}

		dashboard_url_from_pb_url( pb_url: string ) {
			try {
				const url = new URL( pb_url )
				if( !url.hostname.startsWith( 'pb.' ) ) return this.dashboard_url_default()
				return this.dashboard_url_normalize( `${ url.protocol }//dashboard.${ url.hostname.slice( 3 ) }` )
			} catch {
				return this.dashboard_url_default()
			}
		}

		pb_url_override( next?: string ) {
			return this.$.$mol_state_local.value< string >( this.$.$shm_pb.url_store_key(), next ) ?? ''
		}

		dashboard_pb_url( dashboard_url = this.dashboard_url() ) {
			if( dashboard_url.includes( 'dashboard.localhost' ) ) return 'http://127.0.0.1:8090'
			try {
				const url = new URL( dashboard_url )
				if( !url.hostname.startsWith( 'dashboard.' ) ) return this.$.$shm_pb.default_url()
				return `${ url.protocol }//pb.${ url.hostname.slice( 'dashboard.'.length ) }`
			} catch {
				return this.$.$shm_pb.default_url()
			}
		}

		override dashboard_url( next?: string ) {
			if( next !== undefined ) {
				const url = this.dashboard_url_known( next )
					? next
					: this.dashboard_url_default()
				this.message( '' )
				this.pb_url_override( this.dashboard_pb_url( url ) )
				return url
			}

			const override = this.pb_url_override() || this.$.$shm_pb.default_url()
			const url = this.dashboard_url_from_pb_url( override )
			return this.dashboard_url_known( url ) ? url : this.dashboard_url_default()
		}

		state_key( key: string ) {
			return this.$.$shm_pb.admin_auth_store_key( key )
		}

		state( key: string, next?: string | null ) {
			return this.$.$mol_state_local.value< string >( this.state_key( key ), next )
		}

		pb_url() {
			return this.dashboard_pb_url()
		}

		collection() {
			return '_superusers'
		}

		email( next?: string ) {
			if( next !== undefined ) {
				this.message( '' )
				return this.state( 'email', next ) ?? ''
			}
			return this.state( 'email' ) || ''
		}

		@ $mol_mem
		password( next?: string ) {
			if( next !== undefined ) this.message( '' )
			return next ?? ''
		}

		token( next?: string ) {
			if( next !== undefined ) return this.state( 'token', next ) ?? ''
			return this.state( 'token' ) || ''
		}

		user_id( next?: string ) {
			if( next !== undefined ) return this.state( 'user_id', next ) ?? ''
			return this.state( 'user_id' ) || ''
		}

		@ $mol_mem
		message( next?: string ) {
			return next ?? ''
		}

		submit_enabled() {
			return Boolean( this.email().trim() && this.password() )
		}

		auth_url() {
			const base = this.pb_url().trim().replace( /\/+$/, '' )
			const collection = encodeURIComponent( this.collection() )
			return `${ base }/api/collections/${ collection }/auth-with-password`
		}

		auth_body() {
			return JSON.stringify({
				identity: this.email().trim(),
				password: this.password(),
			})
		}

		auth_error_message( data: unknown, fallback: string ) {
			const message = ( data as { message?: unknown } | null )?.message
			return String( message || fallback )
		}

		@ $mol_action
		submit( next?: Event ) {
			if( next === undefined ) return null

			this.pb_url_override( this.pb_url() )
			this.message( 'Авторизация...' )

			const auth = $mol_error_fence(
				()=> {
					const response = this.$.$mol_fetch.response( this.auth_url(), {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: this.auth_body(),
					} )
					const data = response.json() as $shm_dashboard_admin_auth_response

					if( !response.ok() ) {
						throw new Error( this.auth_error_message( data, response.message() ) )
					}

					return data
				},
				error => {
					this.message( error.message )
					return null
				},
				promise => promise,
			)

			if( !auth || $mol_promise_like( auth ) ) return next

			this.token( auth.token || '' )
			this.user_id( auth.record?.id || '' )
			if( auth.record?.email ) this.email( auth.record.email )
			this.message( `Вход выполнен${ auth.record?.email ? `: ${ auth.record.email }` : '' }` )
			this.password( '' )

			return next
		}

		content_rows() {
			return this.$.$shm_pb.admin_authenticated() ? [ this.Session() ] : [ this.Login_form() ]
		}

		superuser_label() {
			return this.email().trim() || this.user_id().trim() || 'superuser'
		}

		@ $mol_action
		logout( next?: Event ) {
			if( next === undefined ) return null
			this.token( '' )
			this.user_id( '' )
			this.password( '' )
			this.message( '' )
			return next
		}


	}

}
